import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { TranslatorContext } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { DropdownSelectField, InputField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './ProfessionalsWorksAppBusinessComponent.module.scss';
import metadata from './ProfessionalsWorksAppBusinessComponent.metadata.json5';

function ProfessionalsWorksAppBusinessComponent(props) {

    const {
        data: ProfessionalsthatworksatApplicantVM,
        updateWizardData,
        submissionVM,
        ProfessionalsWorksAppBusinessComponentPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addProfessionalsthatworksatApplicant = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            ProfessionalsthatworksatApplicantVM.value = ProfessionalsthatworksatApplicantVM.value || []

            const { _xCenter, _dtoName } = ProfessionalsthatworksatApplicantVM;

            const ProfessionalsthatworksatApplicantObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            ProfessionalsthatworksatApplicantVM.pushElement(
                ProfessionalsthatworksatApplicantObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, ProfessionalsthatworksatApplicantVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            ProfessionalsthatworksatApplicantVM.value.splice(index, 1);
            _.set(submissionVM.value, ProfessionalsWorksAppBusinessComponentPath, ProfessionalsthatworksatApplicantVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, ProfessionalsWorksAppBusinessComponentPath, ProfessionalsthatworksatApplicantVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'namOfPro1') {
                const value = item.namOfPro1 ? item.namOfPro1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namOfPro1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'cliNam2') {
                const value = item.cliNam2 ? item.cliNam2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.cliNam2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'proDes3') {
                const value = (item && item.proDes3) ? item.proDes3 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = ProfessionalsthatworksatApplicantVM.children[index].proDes3
                    // eslint-disable-next-line security/detect-object-injection
                    ? ProfessionalsthatworksatApplicantVM.children[index].proDes3.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.proDes3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'priIns4') {
                const value = item.priIns4 ? item.priIns4 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.priIns4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, translator, ProfessionalsthatworksatApplicantVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`ProfessionalsthatworksatApplicantTable`]: {
            data: ProfessionalsthatworksatApplicantVM.value,
        }

    }), [ProfessionalsthatworksatApplicantVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addProfessionalsthatworksatApplicant,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            ProfessionalsthatworksatApplicantVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [ProfessionalsthatworksatApplicantVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={ProfessionalsthatworksatApplicantVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProfessionalsWorksAppBusinessComponent.propTypes = wizardProps;
export default withRouter(ProfessionalsWorksAppBusinessComponent);
